// extracted by mini-css-extract-plugin
export default {"wrapper":"GoalProgress_wrapper__63DG5","header":"GoalProgress_header__5MswW","body":"GoalProgress_body__kPKaZ"};